module.exports = __webpack_public_path__ + "media/3_15.f4a10884.wav";